import { render, staticRenderFns } from "./duplicateSettings.vue?vue&type=template&id=ed12add2&scoped=true"
import script from "./duplicateSettings.vue?vue&type=script&lang=js"
export * from "./duplicateSettings.vue?vue&type=script&lang=js"
import style0 from "./duplicateSettings.vue?vue&type=style&index=0&id=ed12add2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed12add2",
  null
  
)

export default component.exports